import { AtSign } from 'lucide-react';
import { useState, type FormEvent } from 'react';
import { Navigate } from 'react-router-dom';

import { ApiError } from '../lib/api.js';
import { useAuth } from '../lib/auth.js';

export function LoginPage() {
  const { admin, isLoading, login } = useAuth();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [err, setErr] = useState<string | null>(null);
  const [submitting, setSubmitting] = useState(false);

  if (isLoading) return null;
  if (admin) return <Navigate to="/app" replace />;

  const onSubmit = (e: FormEvent) => {
    e.preventDefault();
    setErr(null);
    setSubmitting(true);
    login(email, password)
      .catch((e: unknown) => {
        setErr(e instanceof ApiError ? e.message : String(e));
      })
      .finally(() => setSubmitting(false));
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-slate-50 px-4 dark:bg-slate-950">
      <div className="w-full max-w-sm rounded-2xl border border-slate-200 bg-white p-8 shadow-sm dark:border-slate-800 dark:bg-slate-900">
        <div className="mb-6 flex items-center gap-2.5">
          <div className="flex h-10 w-10 items-center justify-center rounded-xl bg-brand-500 text-white">
            <AtSign className="h-5 w-5" />
          </div>
          <div>
            <div className="text-base font-semibold">AliasHub</div>
            <div className="text-xs text-slate-500 dark:text-slate-400">
              Email Alias &amp; Inbox
            </div>
          </div>
        </div>
        <h1 className="text-lg font-semibold">登录</h1>
        <p className="mt-1 text-sm text-slate-500 dark:text-slate-400">Single Admin 登录</p>
        <form onSubmit={onSubmit} className="mt-5 space-y-3">
          <div>
            <label className="mb-1 block text-xs font-medium text-slate-600 dark:text-slate-300">
              邮箱
            </label>
            <input
              type="email"
              required
              autoComplete="username"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="h-10 w-full rounded-lg border border-slate-200 bg-white px-3 text-sm outline-none focus:border-brand-400 dark:border-slate-700 dark:bg-slate-950"
            />
          </div>
          <div>
            <label className="mb-1 block text-xs font-medium text-slate-600 dark:text-slate-300">
              密码
            </label>
            <input
              type="password"
              required
              autoComplete="current-password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="h-10 w-full rounded-lg border border-slate-200 bg-white px-3 text-sm outline-none focus:border-brand-400 dark:border-slate-700 dark:bg-slate-950"
            />
          </div>
          {err ? (
            <div className="rounded-lg bg-red-50 px-3 py-2 text-xs text-red-700 dark:bg-red-500/10 dark:text-red-300">
              {err}
            </div>
          ) : null}
          <button
            type="submit"
            disabled={submitting}
            className="h-10 w-full rounded-lg bg-brand-500 text-sm font-medium text-white hover:bg-brand-600 disabled:opacity-50"
          >
            {submitting ? '登录中…' : '登录'}
          </button>
        </form>
      </div>
    </div>
  );
}
